import { z } from "zod";

import { packagingComponentBaseSavedSchema } from "./packaging-component-base-saved";
import { placementSchema } from "./placement";

export const packagingComponentPrintSavedSchema = packagingComponentBaseSavedSchema.extend({
	placement: placementSchema,
	rotation: z.number(),
	layer: z.number().optional(),
	cost: z.number(),
	value: z.string().nullish(),
	requiredTimeToPack: z.string().optional(),
});

export type PackagingComponentPrintSaved = z.infer<typeof packagingComponentPrintSavedSchema>;
